import * as React from 'react';
import {useState, useEffect, useRef} from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';

import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {withRouter} from 'react-router';
import Button from '@material-ui/core/Button';
import {instantTakeStatusAPI} from 'api/instant-rake-status.js';
import {DateUtil} from 'utils/date-util.js';
import {ErrorUtil} from 'utils/error-util.js';

import {sessionState} from 'session/session-state.js';

import {GlobalCss} from 'components/global-css.js';
import {ErrorMessage} from 'components/ErrorMessage.js';

const styles = {
  flexContainer: GlobalCss.flexContainer,
  leftJustifiedIitem: GlobalCss.leftJustifiedIitem,
  rightJustifiedIitem: GlobalCss.rightJustifiedIitem,
};

const initialJobStatus = {
  status: '',
  startAt: '',
  endAt: '',
  executeCount: '',
};
const EcsTasksIndex = (props) => {
  const initialState = props.location.state;

  const [taskName, setTaskName] = useState(
    (initialState && initialState.taskName) || sessionState.lastEcsTaskName() || 'milking_summary:monthly'
  );
  const [errorMessage, setErrorMessage] = useState('');
  const [jobStatus, setJobStatus] = useState(initialJobStatus);
  const hasStartedJob = useRef(false);

  const env = process.env.REACT_APP_ENVIRONMENT || 'local';
  const refreshStatus = () => {
    if (!taskName) return;
    if (!initialState || !initialState.waitingJob) return;

    const toStatusLabel = (status) => {
      switch (status) {
      case 'success': {
        return '完了';
      }
      case 'proccessing': {
        return '処理中';
      }
      case 'error': {
        return 'エラー';
      }
      case 'abend': {
        return '異常終了';
      }
      case 'waiting': {
        return '処理待ち';
      }
      default: {
        return '';
      }
      }
    };

    return instantTakeStatusAPI.show(`InstantRake-${taskName}`).then((res) => {
      const record = res.data;
      const isCurrentJob = initialState.executionRequestedAt && record.startAt >= initialState.executionRequestedAt;
      if (!hasStartedJob.current && record.status !== 'proccessing' && !isCurrentJob) return;
      hasStartedJob.current = true;

      const jobStatus = {
        status: toStatusLabel(record.status),
        startAt: DateUtil.toJapaneseYYYYMMDDHHmm(record.startAt),
        endAt: DateUtil.toJapaneseYYYYMMDDHHmm(record.endAt),
        executeCount: record.status === 'success' ? record.executeCount : '',
      };

      setJobStatus(jobStatus);
    }).catch((error) => {
      const errorMessage = ErrorUtil.generateMessage(error);
      setErrorMessage(errorMessage);
      console.error(errorMessage);
    });
  };

  useEffect(() => {
    if (initialState && initialState.waitingJob) {
      const record = {
        status: '処理待ち',
        startAt: '',
        endAt: '',
        executeCount: '',
      };
      setJobStatus(record);
    } else {
      refreshStatus();
    }
    // ※ESlintの余分な警告を回避するための措置
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createParams = () => {
    return {
      pathname: '/ecs_tasks/confirm',
      state: {
        taskName: taskName,
        environment: env
      }
    };
  };

  const createAction = () => {
    const result = validate();
    if (!result.valid) {
      setErrorMessage(result.errors.join('\n'));
      return;
    } else {
      setErrorMessage('');
    }
    props.history.push(createParams());
  };

  const validate = () => {
    const errors = [];

    if (!taskName) {
      errors.push('タスク名称を選択して下さい');
    }

    return {valid: errors.length === 0, errors: errors};
  };

  const isDisabled = taskName === '';

  return (
    <div style={{marginLeft: '20px'}}>
      <h2>ECSタスク実行</h2>

      <div style={{marginLeft: '40px'}}>
        <ErrorMessage errorMessage={errorMessage} />
      </div>

      <ul className={props.classes.flexContainer}>
        <li>
          <InputLabel htmlFor="ecs-tasks" style={{fontSize: 16, marginLeft: 40, marginBottom: 20, marginTop: 20}}>ECSタスク名称</InputLabel>
          <Select
            inputProps={{name: 'ecs-tasks', id: 'ecs-tasks'}}
            style={{minWidth: 680, marginLeft: 40, marginBottom: 20}}
            onChange={(e) => {
              sessionState.changeLastEcsTaskName(e.target.value);
              setTaskName(e.target.value);
              setJobStatus(initialJobStatus);
              hasStartedJob.current = false;
            }}
            value={taskName}
          >
            <MenuItem value={'milking_summary:monthly'}>搾乳量集計(月次)（milking_summary:monthly）</MenuItem>
            <MenuItem value={'correct_cow_state:run'}>牛個体状態補正（correct_cow_state:run）</MenuItem>
            <MenuItem value={'cow_group_history:recently_days'}> 牛群移動履歴（cow_group_history:recently_days）</MenuItem>
            <MenuItem value={'correct_moved_event:run'}> 牛群移動イベントの補正（correct_moved_event:run）</MenuItem>
          </Select>
        </li>

        <li style={{marginLeft: '100px'}}>
          <Button variant="contained" color="primary" onClick={() => createAction()} disabled={isDisabled}>
            実行
          </Button>
        </li>
      </ul>

      <div style={{marginTop: 50, marginLeft: 50}}>
        <div style={{fontSize: 20, marginLeft: 30}}>
          処理状況
        </div>

        <ul className={props.classes.flexContainer} style={{marginBottom: 10}}>
          <li style={{width: 120, marginTop: 10}}>
            <InputLabel style={{fontWeight: 'bold', marginTop: 5}}>ステータス:</InputLabel>
          </li>
          <li style={{paddingTop: 5}}>
            <TextField
              type="text"
              required={true}
              placeholder=""
              value={jobStatus && jobStatus.status}
              disabled={true}
              margin="none"
              style={{width: 80}}
            />
          </li>
        </ul>

        <ul className={props.classes.flexContainer} style={{marginBottom: 10}}>
          <li style={{width: 120, marginTop: 10}}>
            <InputLabel style={{fontWeight: 'bold', marginTop: 5}}>開始時刻:</InputLabel>
          </li>
          <li style={{paddingTop: 5}}>
            <TextField
              type="text"
              required={true}
              placeholder=""
              value={jobStatus && jobStatus.startAt}
              disabled={true}
              margin="none"
            />
          </li>
        </ul>

        <ul className={props.classes.flexContainer} style={{marginBottom: 10}}>
          <li style={{width: 120, marginTop: 10}}>
            <InputLabel style={{fontWeight: 'bold', marginTop: 5}}>終了時刻:</InputLabel>
          </li>
          <li style={{paddingTop: 5}}>
            <TextField
              type="text"
              required={true}
              placeholder=""
              value={jobStatus && jobStatus.endAt}
              disabled={true}
              margin="none"
            />
          </li>
        </ul>

        <ul className={props.classes.flexContainer} style={{marginBottom: 10}}>
          <li style={{width: 120, marginTop: 10}}>
            <InputLabel style={{fontWeight: 'bold', marginTop: 5}}>処理件数:</InputLabel>
          </li>
          <li style={{paddingTop: 5}}>
            <TextField
              type="text"
              required={true}
              placeholder=""
              value={jobStatus && jobStatus.executeCount}
              disabled={true}
              margin="none"
              style={{width: 80}}
            />
          </li>
        </ul>

        <div style={{marginTop: 30, marginLeft: 220}}>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => refreshStatus()}
          >
            処理状況更新
          </Button>
        </div>
      </div>
    </div>
  );
};

EcsTasksIndex.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

const forExport = withRouter(withStyles(styles)(EcsTasksIndex));
export {forExport as EcsTasksIndex};
